import axios from "axios";
export const updatePreferredExchanges=(exchanges)=>{
    return axios.put('/api/v1/user/preferred-exchanges',{exchanges})
}

export const getAdminOverview = () => axios.get('/api/v1/user/admin-overview');
